export default ['JsonRPCService', function (JsonRPCService) {
    return {
        policyLocationChange: function policyLocationChange(quote, location, action) {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'policyLocationChange', [quote, location, action]);
        },
        coverageChange: function coverageChange(quote, coverage, action) {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'coverageChange', [quote, coverage, action]);
        },
        coveredEmployeeChange: function coveredEmployeeChange(quote, employee, action) {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'coveredEmployeeChange', [quote, employee, action]);
        },

        getRiskIdByNumber: function getRiskIdByNumber(riskId) {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'getRiskIdByNumber', [riskId]);
        },
        getPerCapitaCodes: function getPerCapitaCodes() {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'getPerCapitaCodes');
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/services/QuoteService.js
// module id = 1311
// module chunks = 0